import styled from "styled-components";
import colors from "styles/colors";

const StyledFooter = styled.footer`
  font-family: "Poppins", sans-serif;
  color: white;
  text-align: center;
  background: ${colors.backgroundLighter};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
`;

const RedMorphX = styled.a`
  font-family: "Poppins", sans-serif;
  font-size: 0.9em;
  font-weight: 400;
  text-align: center;
  // color: rgb(128, 128, 128);
  color: rgb(50, 50, 50);
  text-decoration: none;

  @media (max-width: 480px) {
    font-size: 0.7em;
  }
`;

const CopyrightSymbol = styled.span`
  font-weight: 400;
  font-size: 1.3em;
  margin-right: 0.2em;
  // color: rgb(119, 119, 119);
  color: rgb(50, 50, 50);

  @media (max-width: 480px) {
    font-size: 1em;
  }
`;

const CopyrightYear = styled.span`
  // color: rgb(128, 128, 128);
  color: rgb(50, 50, 50);
  font-size: 0.9em;
  font-weight: 400;

  @media (max-width: 480px) {
    font-size: 0.7em;
  }
`;

const Footer = ({ isFixed = false }: { isFixed?: boolean }): JSX.Element => (
  <StyledFooter style={isFixed ? { position: "relative" } : undefined}>
    <RedMorphX
      href="https://redmorphx.com"
      target="_blank"
      rel="noopener noreferrer"
    >
      RedMorphX
    </RedMorphX>
    <CopyrightSymbol>&nbsp;©</CopyrightSymbol>
    <CopyrightYear>2026&nbsp;</CopyrightYear>
  </StyledFooter>
);

export default Footer;
